import dayjs from 'dayjs';

import { getNotificationEventsUrl } from './urls';
import { StrapiHsmEvent } from './types';

import { stringToDate } from '@/utils/date';
import {
  HsmBackendHttpClient,
  HsmBackendResponseList,
} from '@/utils/http-client';

export async function getNotificationEvents(
  websiteId: string,
  dateRange?: string[]
): Promise<StrapiHsmEvent[]> {
  const client = HsmBackendHttpClient.instance;

  let dateFrom = dayjs().subtract(1, 'month').toDate();
  let dateTo = new Date();

  if (dateRange && dateRange.length === 2) {
    dateFrom = stringToDate(dateRange[0]);
    dateTo = stringToDate(dateRange[1]);
  }

  const from = dateFrom.toISOString();
  const to = dayjs(dateTo).add(1, 'day').toISOString();

  const { result } = await client.get<HsmBackendResponseList<StrapiHsmEvent>>(
    getNotificationEventsUrl(websiteId, from, to)
  );

  return result;
}
